<template>
  <div class="pa-4">
    <v-row class="mb-4 align-center">
      <v-col cols="auto">
        <Breadcrump :crumbs="crumbs" />
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn @click="$router.go(-1)" fab small dark color="indigo">
          <v-icon dark>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="lastSmsStatus && sendSmsStatus">
      <v-col cols="12" md="8" lg="8">
        <v-card class="mb-4" elevation="2" :loading="smsStatusLoading">
          <v-card-text class="pa-4">
            <div class="d-flex align-center mb-3">
              <v-icon
                :color="getSmsStatusColor(lastSmsStatus.success)"
                class="ml-2"
                >mdi-information</v-icon
              >
              <span class="font-weight-bold">آخرین وضعیت پیامک</span>
            </div>

            <v-row dense>
              <v-col cols="12" sm="6" class="py-1">
                <div class="d-flex align-center">
                  <span class="grey--text ml-2" style="min-width: 70px;"
                    >وضعیت:</span
                  >
                  <v-chip
                    :color="getSmsStatusColor(lastSmsStatus.success)"
                    dark
                    small
                  >
                    {{ getSmsStatusText(lastSmsStatus.success) }}
                  </v-chip>
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                class="py-1"
                v-if="lastSmsStatus.identity"
              >
                <div class="d-flex align-center">
                  <span class="grey--text ml-2" style="min-width: 70px;"
                    >شناسه:</span
                  >
                  <span class="text-body-2">{{ lastSmsStatus.identity }}</span>
                </div>
              </v-col>

              <v-col cols="12" class="py-1" v-if="lastSmsStatus.errorMessage">
                <div class="d-flex align-center">
                  <span class="grey--text ml-2" style="min-width: 70px;"
                    >خطا:</span
                  >
                  <span class="text-body-2">{{
                    lastSmsStatus.errorMessage
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="10" lg="8">
        <v-textarea
          v-model="content"
          auto-grow
          label="متن"
          outlined
          rows="2"
          row-height="25"
          shaped
          hide-details="auto"
          class="mb-4"
        ></v-textarea>

        <v-textarea
          label="متن باشگاه مشتریان"
          auto-grow
          v-model="customerClubSmsContent"
          outlined
          rows="2"
          row-height="25"
          shaped
          hide-details="auto"
          class="mb-4"
        ></v-textarea>

        <v-textarea
          v-if="sendWinGameSmsStatus"
          label="متن پیامک برد"
          auto-grow
          v-model="winGameSms"
          :class="winGameSmsWarningClass"
          outlined
          :error-messages="!winGameSms ? 'متن پیامک برد انتخاب نشده است' : ''"
          rows="2"
          row-height="25"
          shaped
          hide-details="auto"
          disabled
          class="mb-4"
        ></v-textarea>
        <v-textarea
          v-if="sendLoseGameSmsStatus"
          label="متن پیامک باخت"
          auto-grow
          v-model="loseGameSms"
          :class="loseGameSmsWarningClass"
          :error-messages="!loseGameSms ? 'متن پیامک باخت انتخاب نشده است' : ''"
          outlined
          rows="2"
          row-height="25"
          shaped
          hide-details="auto"
          disabled
          class="mb-4"
        ></v-textarea>

        <v-btn
          color="blue darken-1"
          dark
          v-can="`SmsContent_Edit`"
          @click="submit()"
        >
          <v-icon left small>mdi-content-save</v-icon>
          ذخیره
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import request from "@/utils/request";
import Breadcrump from "@/components/common/Breadcrump.vue";
import Vue from "vue";

export default {
  name: "DeviceSmsPanel",
  components: {
    Breadcrump
  },
  data() {
    return {
      crumbs: [
        { text: "خانه", disabled: false, href: "/" },
        { text: "مجموعه ها", disabled: false, href: "/complexes" },
        {
          text: `مجموعه ${this.$store.state.selectedComplexName || ""}`,
          disabled: false,
          href: `/complex-units/${this.$store.state.selectedComplexId}`
        },
        {
          text: this.$store.state.selectedDeviceName || "دستگاه",
          href: `/complex-devices/${this.$store.state.selectedComplexId}`,
          disabled: false
        },
        { text: "پنل پیامک", disabled: true }
      ],
      selectedComplexId: null,
      content: null,
      customerClubSmsContent: null,
      deviceId: 0,
      lastSmsStatus: null,
      sendSmsStatus: false,
      smsStatusLoading: false,
      loseGameSms: null,
      winGameSms: null,
      sendWinGameSmsStatus: false,
      sendLoseGameSmsStatus: false
    };
  },
  computed: {
    winGameSmsWarningClass() {
      return !this.winGameSms ? "warning-border" : "";
    },
    loseGameSmsWarningClass() {
      return !this.loseGameSms ? "warning-border" : "";
    }
  },
  created() {
    this.deviceId = parseInt(this.$route.params.id);
    this.selectedComplexId = this.$store.state.selectedComplexId;
    this.getSmsContent();
  },
  methods: {
    getSmsContent() {
      request.get(`/device/sms-content/${this.deviceId}`).then(response => {
        const data = response.data.result;
        this.content = data.content;
        this.customerClubSmsContent = data.customerClubSmsContent;
        this.lastSmsStatus = data.smsLastState;
        this.sendSmsStatus = data.sendSmsStatus;
        this.winGameSms = data.winGameSms;
        this.loseGameSms = data.loseGameSms;
        this.sendWinGameSmsStatus = data.sendWinGameSmsStatus;
        this.sendLoseGameSmsStatus = data.sendLoseGameSmsStatus;
        this.id = data.id;
      });
    },

    submit() {
      request
        .put(`/device/sms-content/${this.deviceId}`, {
          content: this.content,
          customerClubSmsContent: this.customerClubSmsContent
        })
        .then(() => {
          Vue.swal("", "اطلاعات با موفقیت ذخیره گردید", "success");
        });
    },

    getSmsStatusColor(success) {
      if (success === true) return "green darken-1";
      if (success === false) return "red darken-1";
      return "blue";
    },

    getSmsStatusText(success) {
      if (success === true) return "موفق";
      if (success === false) return "ناموفق";
      return "نامشخص";
    },

    getSmsStatusIcon(success) {
      if (success === true) return "mdi-check-circle";
      if (success === false) return "mdi-alert-circle";
      return "mdi-help-circle";
    }
  }
};
</script>

<style scoped>
.pa-4 {
  padding: 20px;
}
.warning-border >>> fieldset,
.warning-border >>> .v-input__control {
  border-color: #fb8c00 !important;
  opacity: 75%;
}
.warning-border >>> .v-label {
  color: #fb8c00 !important;
  opacity: 75%;
}
.warning-border >>> .v-messages__message {
  color: #fb8c00 !important;
  opacity: 75%;
}
.warning-border >>> .v-input--is-disabled fieldset {
  border-color: #fb8c00 !important;
  opacity: 75%;
}
</style>
